import { useState, useEffect, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Avatar, Loading, getDefaultUser, LogotypePDK, Hamburger, Logout, Envelope } from "wup-module1-base";
import { faBars, faComment, faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";

import { UserContext } from "../../Contexts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AuthService } from "../../Services/Auth/AuthService";
import { ContactModal } from "..";

import "./Header.css";
import { BoxArrowRight, EnvelopeFill } from "react-bootstrap-icons";

function Header() {
  const [duringLogout, setDuringLogout] = useState(false);
  const [contactModalIsOpen, setOpenContactModal] = useState(false);
  const [avatarSize, setAvatarSize] = useState(62)

  const navigate = useNavigate();
  const { user, setUser } = useContext(UserContext);

  const logout = () => {
    setDuringLogout(true);
    AuthService.logout()
      .then((response) => {
        setUser(getDefaultUser());
        navigate("/login");
      })
      .catch((error) => { })
      .finally(() => {
        setDuringLogout(false);
        sessionStorage.clear();
        localStorage.clear();
      });
  };

  const openformContact = () => {
    setOpenContactModal(true);
  };
  
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1080) {
        setAvatarSize(45);
      } else {
        setAvatarSize(62);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <nav className="navbar navbar-expand main-header header__container">
        <div className="navbar-nav">
          <div className="nav-item">
            <button
              className="nav-bars header__hamburger"
              data-widget="pushmenu"
              aria-label="Zwijanie menu"
            >
              <img
                className="logo header__hamburger-icon"
                src={Hamburger}
                aria-hidden="true"
                alt="Menu"
              />

            </button>
          </div>
        </div>
        <div className="navbar-nav">
          <div className="nav-item">
            <img
              className="logo header__hamburger-logo"
              src={LogotypePDK}
              alt="Logo MAŁOPOLSKI POCIĄG DO KARIERY"
            />
          </div>
        </div>
        <div className="navbar-nav ml-auto">
          <div className="nav-item">
            <button
              className="header__contact-us-button"
              onClick={openformContact}
              title="Formularz kontaktu"
              id="formBtn"
            >
              <img
                className="header__contact-us-icon"
                src={Envelope}
                alt="Formularz kontaktu"
              />
              <span className="header__contact-us-label">kontakt</span>
            </button>
          </div>
          <div className="nav-item">
            <div className="header__avatar-container">
              <Avatar
                firstName={user?.firstName ?? "Imię"}
                lastName={user?.lastName ?? "Nazwisko"}
                className="header__avatar"
                size={avatarSize}
                color="#663399"
              />
              <div className="header__avatar-label">
                {`${user?.firstName ?? "Imię"} ${user?.lastName ?? "Nazwisko"}`}
              </div>
            </div>
          </div>
          <div className="nav-item">
            {!duringLogout ? (
              <button
                className="header__logout-button"
                onClick={logout}
                title="Wyloguj"
                id="logoutBtn"
              >
                <img
                  className="header__logout-icon"
                  src={Logout}
                  aria-hidden="true"
                  alt="Wyloguj"
                />
              </button>
            ) : (
              <Loading className="header__logout-loading" size="xl" />
            )}
          </div>
        </div>
      </nav>
      <ContactModal setOpenContactModal={setOpenContactModal} contactModalIsOpen={contactModalIsOpen} userId={user.id} />
    </>
  );
}

export default Header;
